import Vue from 'vue'
import VueRouter from 'vue-router'
import WelcomePage from '../views/WelcomePage'
import AboutPage from '../views/AboutPage'
import BenefitsPage from '../views/BenefitsPage'
import Products from '../views/Products'
import Product from '../views/Product'
import ProfilePage from '../views/ProfilePage'
import TermsAndConditionsPage from '../views/TermsAndConditionsPage'
import PageNotFound from '../views/PageNotFound'
import Donation from '../views/DonationPage'
import VueJwtDecode from 'vue-jwt-decode'
import AccountsPage from '../views/AccountsPage'
import MyAccount from '../components/profilePage/MyAccount'
import MyProducts from '../components/profilePage/MyProducts'
import MyFriends from '../components/profilePage/MyFriends'
import Notifications from '../components/profilePage/Notifications'
import Settings from '../components/profilePage/Settings'
import MyGroups from '../components/profilePage/MyGroups'
import Needs from '../views/Needs'
import currentGroup from '../components/profilePage/currentGroup'
import store from '../store/index'
import AddNeeds from '../components/profilePage/AddNeeds'
import Need from '../components/products/Need'
import GetInTouch from '../components/welcomePage/GetInTouch'
Vue.use(VueRouter)

const Router = new VueRouter({
  mode: 'history',
  fallback: false,
  routes: [
    {
      path: '/',
      name: 'WelcomePage',
      component: WelcomePage,
      meta: {
        title: 'The Art Of Giving'
      }
    },
    {
      path: '/terms-and-conditions',
      name: 'TermsAndConditionsPage',
      component: TermsAndConditionsPage,
      meta: {
        title: 'Terms and Conditions'
      }
    },
    {
      path: '/contact',
      name: 'get-in-touch',
      component: GetInTouch,
      meta: {
        title: 'Get In Touch'
      }
    },
    {
      path: '/about',
      name: 'AboutPage',
      component: AboutPage,
      meta: {
        title: 'About Us'
      }
    },
    {
      path: '/benefits',
      name: 'BenefitsPage',
      component: BenefitsPage,
      meta: {
        title: 'Benefits'
      }
    },
    {
      path: '/donation',
      name: 'Donation',
      component: Donation,
      meta: {
        title: 'Donation'
      }
    },
    {
      path: '/needs',
      name: 'Needs',
      component: Needs,
      meta: {
        title: 'Needs'
      }
    },
    {
      path: '/need/:needId/:needName',
      name: 'need',
      component: Need,
      meta: {
        title: 'Need'
      }
    },
    {
      path: '/forgotPassword',
      name: 'ForgotPassword',
      component: WelcomePage
    },
    {
      path: '/confirmEmail',
      name: 'confirmEmail',
      component: WelcomePage
    },
    {
      path: '/verificationEmail',
      name: 'verificationEmail',
      component: WelcomePage
    },
    {
      path: '/confirmEmailCompany',
      name: 'confirmEmailCompany',
      component: WelcomePage
    },
    {
      path: '/products',
      name: 'products',
      component: Products,
      meta: {
        title: 'Gifts'
      }
    },
    {
      path: '/products/:productId/:productName',
      name: 'product',
      component: Product,
      meta: {
        title: 'Product'
      }
    },
    {
      path: '/profile',
      name: 'ProfilePage',
      component: ProfilePage,
      meta: {
        title: 'Profile',
        isAuthenticated: true,
        rolePermissions: ['user', 'admin', 'company']
      },
      children: [
        {
          path: 'my-account',
          name: 'ProfileMyAccount',
          component: MyAccount,
          meta: {
            title: 'My Account',
            isAuthenticated: true,
            rolePermissions: ['user', 'admin', 'company']
          }
        },
        {
          path: 'my-products',
          name: 'ProfileMyProducts',
          component: MyProducts,
          props: true,
          meta: {
            title: 'My Products',
            isAuthenticated: true,
            rolePermissions: ['user', 'admin', 'company']
          }
        },
        {
          path: 'my-friends',
          name: 'ProfileMyFriends',
          component: MyFriends,
          meta: {
            title: 'My Friends',
            isAuthenticated: true,
            rolePermissions: ['user', 'admin', 'company']
          }
        },
        {
          path: 'notifications',
          name: 'ProfileNotifications',
          component: Notifications,
          meta: {
            title: 'Notifications',
            isAuthenticated: true,
            rolePermissions: ['user', 'admin', 'company']
          }
        },
        {
          path: 'settings',
          name: 'ProfileSettings',
          component: Settings,
          meta: {
            title: 'Settings',
            isAuthenticated: true,
            rolePermissions: ['admin']
          }
        },
        {
          path: 'add-needs',
          name: 'AddNeeds',
          component: AddNeeds,
          meta: {
            title: 'AddNeeds',
            isAuthenticated: true,
            rolePermissions: ['admin']
          }
        },
        {
          path: 'my-groups',
          name: 'ProfileMyGroups',
          component: MyGroups,
          meta: {
            title: 'My Groups',
            isAuthenticated: true,
            rolePermissions: ['user', 'admin', 'company']
          }
        },
        {
          path: 'my-groups/:groupId',
          name: 'group',
          component: currentGroup,
          meta: {
            title: 'Group',
            isAuthenticated: true,
            rolePermissions: ['user', 'admin', 'company']
          }
        }
      ]
    },
    {
      path: '/accounts/:userId',
      name: 'AccountsPage',
      component: AccountsPage,
      meta: {
        title: 'Account'
      }
    },
    {
      path: '*',
      name: 'PageNotFound',
      component: PageNotFound,
      meta: {
        title: 'Not Found'
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.name !== from.name) {
      return { x: 0, y: 0 }
    }
  }
})
// Router.beforeEach((to, from, next) => {
//   // This goes through the matched routes from last to first, finding the closest route with a title.
//   // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
//   const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
//
//   // Find the nearest route element with meta tags.
//   const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
//   const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
//
//   // If a route with a title was found, set the document (page) title to that value.
//   if(nearestWithTitle) document.title = nearestWithTitle.meta.title;
//
//   // Remove any stale meta tags from the document using the key attribute we set below.
//   Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
//
//   // Skip rendering meta tags if there are none.
//   if(!nearestWithMeta) return next();
//
//   // Turn the meta tag definitions into actual elements in the head.
//   nearestWithMeta.meta.metaTags.map(tagDef => {
//     const tag = document.createElement('meta');
//
//     Object.keys(tagDef).forEach(key => {
//       tag.setAttribute(key, tagDef[key]);
//     });
//
//     // We use this to track which meta tags we create, so we don't interfere with other ones.
//     tag.setAttribute('data-vue-router-controlled', '');
//
//     return tag;
//   })
//     // Add the meta tags to the document head.
//     .forEach(tag => document.head.appendChild(tag));
//
//   next();
// });
Router.beforeEach((to, from, next) => {
  document.querySelector('body').classList.remove('stop-chat')
  document.title = 'Giver'
  if (to.meta.title) {
    if (to.params.productName) {
      document.title = sanitizeTitle(to.params.productName)
    } else {
      document.title = document.title + ' | ' + to.meta.title
    }
  }

  if (to.meta.isAuthenticated) {
    let userPermissions = decodeJwtToken()
    if (userPermissions) {
      let accepted = false
      to.meta.rolePermissions.forEach(rolePermission => {
        if (userPermissions.includes(rolePermission)) {
          accepted = true
        }
      })
      if (accepted) {
        next()
      } else {
        store.dispatch('auth/signOut')
        next('/')
      }
    } else {
      store.dispatch('auth/signOut')
      next('/')
    }
  } else {
    next()
  }
})
function decodeJwtToken () {
  let token = localStorage.getItem('token')
  if (token) {
    return VueJwtDecode.decode(token).permissions
  }
}
function sanitizeTitle (title) {
  return title.replace(/-/g, ' ')
}
export default Router



// WEBPACK FOOTER //
// ./src/router/index.js